/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The kind of request the token redeemed into.
 */
export const PolicyBypassRedemptionKind = {
  ApprovalRequest: "approval_request",
  BypassRequest: "bypass_request",
} as const;
/**
 * The kind of request the token redeemed into.
 */
export type PolicyBypassRedemptionKind = OpenEnum<
  typeof PolicyBypassRedemptionKind
>;

/**
 * What a redeemed block-link token turned into: an MCP access request when the approval workflow handles the server, or a legacy policy bypass request otherwise.
 */
export type PolicyBypassRedemption = {
  /**
   * The id of the created or refreshed request.
   */
  id: string;
  /**
   * The kind of request the token redeemed into.
   */
  kind: PolicyBypassRedemptionKind;
  /**
   * The request's current status.
   */
  status: string;
};

/** @internal */
export const PolicyBypassRedemptionKind$inboundSchema: z.ZodMiniType<
  PolicyBypassRedemptionKind,
  unknown
> = openEnums.inboundSchema(PolicyBypassRedemptionKind);

/** @internal */
export const PolicyBypassRedemption$inboundSchema: z.ZodMiniType<
  PolicyBypassRedemption,
  unknown
> = z.object({
  id: z.string(),
  kind: PolicyBypassRedemptionKind$inboundSchema,
  status: z.string(),
});

export function policyBypassRedemptionFromJSON(
  jsonString: string,
): SafeParseResult<PolicyBypassRedemption, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PolicyBypassRedemption$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PolicyBypassRedemption' from JSON`,
  );
}
